import React, { Component } from "react";
import Card from "../Card/Card";
import Chart from "react-apexcharts";
import { barChartData, barChartOptions } from "../../variables/charts";
import { ApexOptions } from "apexcharts";
import { ApexChartSeries } from "../../types/charts";

interface BarChartProps {
  // Add any props if needed in the future
}

interface BarChartState {
  chartData: ApexChartSeries[];
  chartOptions: ApexOptions;
}

class BarChart extends Component<BarChartProps, BarChartState> {
  constructor(props: BarChartProps) {
    super(props);
    this.state = {
      chartData: barChartData || [],
      chartOptions: barChartOptions as ApexOptions || {},
    };
  }

  componentDidMount(): void {
    if (!this.state.chartData || this.state.chartData.length === 0) {
      this.setState({
        chartData: barChartData,
        chartOptions: barChartOptions as ApexOptions,
      });
    }
  }

  render(): JSX.Element {
    const { chartData, chartOptions } = this.state;
    
    // Validate chart data and options before rendering
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return (
        <Card
          py="1rem"
          height={{ sm: "200px" }}
          width="100%"
          bg="linear-gradient(135deg, #38BBD1, #3EEAEC)"
          position="relative"
        />
      );
    }
    
    // Validate each series has data array
    const hasValidData = chartData.every(series => {
      if (!series || typeof series !== 'object') return false;
      if (!series.data) return false;
      if (!Array.isArray(series.data)) return false;
      if (series.data.length === 0) return false;
      // Validate data array contains valid numbers
      return series.data.every(val => typeof val === 'number' || val === null);
    });
    
    if (!hasValidData || !chartOptions || typeof chartOptions !== 'object') {
      return (
        <Card
          py="1rem"
          height={{ sm: "200px" }}
          width="100%"
          bg="linear-gradient(135deg, #38BBD1, #3EEAEC)"
          position="relative"
        />
      );
    }
    
    // Ensure categories array exists and has length if needed
    // Also ensure all array properties are properly initialized
    const safeOptions: ApexOptions = {
      ...chartOptions,
      xaxis: chartOptions.xaxis ? {
        ...chartOptions.xaxis,
        categories: Array.isArray(chartOptions.xaxis.categories) 
          ? chartOptions.xaxis.categories 
          : []
      } : {
        categories: []
      },
      responsive: Array.isArray(chartOptions.responsive) 
        ? chartOptions.responsive 
        : [],
      fill: chartOptions.fill ? {
        ...chartOptions.fill,
        gradient: chartOptions.fill.gradient ? {
          ...chartOptions.fill.gradient,
          stops: Array.isArray(chartOptions.fill.gradient.stops) 
            ? chartOptions.fill.gradient.stops 
            : []
        } : undefined
      } : undefined,
      colors: Array.isArray(chartOptions.colors) 
        ? chartOptions.colors 
        : []
    } as unknown as ApexOptions;
    
    try {
      return (
        <Card
          py="1rem"
          height={{ sm: "200px" }}
          width="100%"
          bg="linear-gradient(135deg, #38BBD1, #3EEAEC)"
          position="relative"
        >
          <Chart
            options={safeOptions}
            series={chartData}
            type="bar"
            width="100%"
            height="100%"
          />
        </Card>
      );
    } catch (error) {
      console.error("BarChart rendering error:", error);
      return (
        <Card
          py="1rem"
          height={{ sm: "200px" }}
          width="100%"
          bg="linear-gradient(135deg, #38BBD1, #3EEAEC)"
          position="relative"
        />
      );
    }
  }
}

export default BarChart;

